import { render, staticRenderFns } from "./AnketInfo.vue?vue&type=template&id=e8020620"
import script from "./AnketInfo.vue?vue&type=script&lang=ts"
export * from "./AnketInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports